// extracted by mini-css-extract-plugin
export default {"homepageView":"homepage_homepageView__YZehB","App-logo-spin":"homepage_App-logo-spin__JBLXP"};